// Learn TypeScript:
//  - https://docs.cocos.com/creator/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/manual/en/scripting/life-cycle-callbacks.html

import comFluency from "../../engines/components/comFluency";

const { ccclass, property } = cc._decorator;

@ccclass
export default class cocosMode extends cc.Component {

    @property(cc.Node)
    pen: cc.Node = null;
    @property(cc.Toggle)
    tg: cc.Toggle = null;
    @property(cc.EditBox)
    ed1: cc.EditBox = null;

    // onLoad () {}
    penY: number;

    start() {
        this.penY = this.pen.y;
        this.ed1.placeholder = '' + cc.game.getFrameRate();
    }

    onBtnSelect() {
        this.pen.getComponent(comFluency).enabled = this.tg.isChecked;
    }

    r: boolean;
    dir: number = 1;

    onEdit() {
        cc.game.setFrameRate(Number(this.ed1.string));
    }

    onBtnStop() {
        // cc.Tween.stopAllByTarget(this.pen);
        // this.pen.y = this.penY;
        this.r = false;
    }

    onBtnPlay() {
        // this.onBtnStop();
        this.r = true;
        // let upDown =
        //     cc.tween(this.pen)
        //         .by(0.0977, { y: 800 })
        //         .by(0.0977, { y: -800 });
        // cc.tween(this.pen)
        //     .then(upDown)
        //     .repeatForever()
        //     .start();

    }

    update(dt) {
        if (this.r) {
            if (this.dir > 0) {
                this.pen.y += 100 * dt / 0.016;
                if (this.pen.y > 800 - 520) {
                    this.dir = -1;
                }
            } else {
                this.pen.y -= 100 * dt / 0.016;
                if (this.pen.y < -520) {
                    this.dir = 1;
                }
            }
        }
    }
}

































